import { useEffect, useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import Solutions from "./components/Solutions";
import HpCatalogEmbed from "./components/HpCatalogEmbed";
import TestimonialSection from "./components/TestimonialSection";
import StrategicPartners from "./components/StrategicPartners";
import StoriesArticles from "./components/StoriesArticles";
import HpServiceBanner from "./components/HpServiceBanner";
import Offices from "./components/Offices";
import CTASection from "./components/CTASection";
import ContactSection from "./components/ContactSection";
import { isFeatureEnabled } from "@/pages/dev-panel/page";

function useFeatureFlags() {
  const [flags, setFlags] = useState(() => ({
    navbar:          isFeatureEnabled("navbar"),
    footer:          isFeatureEnabled("footer"),
    hero_section:    isFeatureEnabled("hero_section"),
    features_section:isFeatureEnabled("features_section"),
    projects_preview:isFeatureEnabled("projects_preview"),
    testimonials:    isFeatureEnabled("testimonials"),
    partners_section:isFeatureEnabled("partners_section"),
    cta_section:     isFeatureEnabled("cta_section"),
    contact_form:    isFeatureEnabled("contact_form"),
  }));

  useEffect(() => {
    // localStorage değişimlerini dinle (aynı sekme için storage event çalışmaz,
    // bu yüzden sayfa odağa gelince yeniden oku)
    const refresh = () => setFlags({
      navbar:          isFeatureEnabled("navbar"),
      footer:          isFeatureEnabled("footer"),
      hero_section:    isFeatureEnabled("hero_section"),
      features_section:isFeatureEnabled("features_section"),
      projects_preview:isFeatureEnabled("projects_preview"),
      testimonials:    isFeatureEnabled("testimonials"),
      partners_section:isFeatureEnabled("partners_section"),
      cta_section:     isFeatureEnabled("cta_section"),
      contact_form:    isFeatureEnabled("contact_form"),
    });
    window.addEventListener("storage", refresh);
    window.addEventListener("focus", refresh);
    return () => {
      window.removeEventListener("storage", refresh);
      window.removeEventListener("focus", refresh);
    };
  }, []);

  return flags;
}

export default function Home() {
  const f = useFeatureFlags();

  return (
    <main className="bg-[#F1F5F9]">
      {f.navbar          && <Navbar />}
      {f.hero_section    && <HeroSection />}
      {f.features_section&& <FeaturesSection />}
      <Solutions />
      {f.projects_preview&& <HpCatalogEmbed />}
      {f.testimonials    && <TestimonialSection />}
      {f.partners_section&& <StrategicPartners />}
      <StoriesArticles />
      <HpServiceBanner />
      <Offices />
      {f.cta_section     && <CTASection />}
      {f.contact_form    && <ContactSection />}
      {f.footer          && <Footer />}
    </main>
  );
}
